export enum PaymentChannel {
  ALIPAY = 'ALIPAY',           // 支付宝
  WECHAT_PAY = 'WECHAT_PAY',   // 微信支付
  UNION_PAY = 'UNION_PAY',     // 银联支付
  PAYPAL = 'PAYPAL',           // PayPal
  STRIPE = 'STRIPE',           // Stripe
  APPLE_PAY = 'APPLE_PAY',     // Apple Pay
  GOOGLE_PAY = 'GOOGLE_PAY',   // Google Pay
}

export enum OrderStatus {
  PENDING = 'PENDING',
  SUCCESS = 'SUCCESS', 
  FAILED = 'FAILED',
  CLOSED = 'CLOSED'
}

export const PAYMENT_CHANNEL_NAMES = {
  [PaymentChannel.ALIPAY]: '支付宝',
  [PaymentChannel.WECHAT_PAY]: '微信支付',
  [PaymentChannel.UNION_PAY]: '银联支付',
  [PaymentChannel.PAYPAL]: 'PayPal',
  [PaymentChannel.STRIPE]: 'Stripe',
  [PaymentChannel.APPLE_PAY]: 'Apple Pay',
  [PaymentChannel.GOOGLE_PAY]: 'Google Pay',
};

export enum ProductType {
  ONE_MONTH_VIP_MEMBERSHIP = '1',
  THREE_MONTH_VIP_MEMBERSHIP = '3',
  ONE_YEAR_VIP_MEMBERSHIP = '12',

  // 橙豆加油包
  ORANGE_BEAN_PACKAGE_300 = 'orange_bean_package_300',
  ORANGE_BEAN_PACKAGE_500 = 'orange_bean_package_500',
  ORANGE_BEAN_PACKAGE_1000 = 'orange_bean_package_1000',
  ORANGE_BEAN_PACKAGE_2000 = 'orange_bean_package_2000',
  ORANGE_BEAN_PACKAGE_3000 = 'orange_bean_package_3000',
}

export const PriceConfig  = {
  [ProductType.ONE_MONTH_VIP_MEMBERSHIP]: 19.9,
  [ProductType.THREE_MONTH_VIP_MEMBERSHIP]: 54.9,
  [ProductType.ONE_YEAR_VIP_MEMBERSHIP]: 189,

  // 橙豆加油包
  [ProductType.ORANGE_BEAN_PACKAGE_300]: 29,   // 0.096
  [ProductType.ORANGE_BEAN_PACKAGE_500]: 45.9, // 0.091
  [ProductType.ORANGE_BEAN_PACKAGE_1000]: 89,  // 0.089
  [ProductType.ORANGE_BEAN_PACKAGE_2000]: 169, // 0.084
  [ProductType.ORANGE_BEAN_PACKAGE_3000]: 239, // 0.079
}

export const SUPPORTED_CURRENCIES = {
  CNY: '人民币',
  USD: '美元',
  EUR: '欧元',
  GBP: '英镑',
  JPY: '日元',
  HKD: '港币',
};

// 交易状态：WAIT_BUYER_PAY（交易创建，等待买家付款）、TRADE_CLOSED（未付款交易超时关闭，或支付完成后全额退款）、TRADE_SUCCESS（交易支付成功）、TRADE_FINISHED（交易结束，不可退款）
export enum AlipayTradeStatus {
  WAIT_BUYER_PAY = 'WAIT_BUYER_PAY',
  TRADE_FINISHED = 'TRADE_FINISHED',
  TRADE_SUCCESS = 'TRADE_SUCCESS',
  TRADE_CLOSED = 'TRADE_CLOSED',
}

interface PlanOption {
  type: ProductType;
  title: string;
  price: number;
  originalPrice?: number;
  duration: string;
  description: string;
  isRecommended?: boolean;
  discount?: string;
  category?: 'vip' | 'points';
}

const calculateAveragePerDay = (price: number, day: number) => {
  const pricePerDay = price / day;
  return pricePerDay.toFixed(2);
}

export const PLAN_OPTIONS: PlanOption[] = [
  {
    type: ProductType.ONE_MONTH_VIP_MEMBERSHIP,
    title: '一个月',
    price: PriceConfig[ProductType.ONE_MONTH_VIP_MEMBERSHIP],
    originalPrice: 29.9,
    duration: `¥${calculateAveragePerDay(PriceConfig[ProductType.ONE_MONTH_VIP_MEMBERSHIP], 30)}/天,每月送150橙豆`,
    description: '一个月',
    discount: '超低价',
    category: 'vip',
  },
  {
    type: ProductType.THREE_MONTH_VIP_MEMBERSHIP,
    title: '三个月',
    price: PriceConfig[ProductType.THREE_MONTH_VIP_MEMBERSHIP],
    originalPrice: 89.9,
    duration: `¥${calculateAveragePerDay(PriceConfig[ProductType.THREE_MONTH_VIP_MEMBERSHIP], 90)}/天,每月送150橙豆`,
    description: '三个月',
    isRecommended: true,
    discount: '超极性价比',
    category: 'vip',
  },
  {
    type: ProductType.ONE_YEAR_VIP_MEMBERSHIP,
    title: '12个月',
    price: PriceConfig[ProductType.ONE_YEAR_VIP_MEMBERSHIP],
    originalPrice: 299,
    duration: `¥${calculateAveragePerDay(PriceConfig[ProductType.ONE_YEAR_VIP_MEMBERSHIP], 365)}/天,每月送150橙豆`,
    description: '12个月',
    discount: '全网最低',
    category: 'vip',
  },
  {
    type: ProductType.ORANGE_BEAN_PACKAGE_300,
    title: '300橙豆',
    price: PriceConfig[ProductType.ORANGE_BEAN_PACKAGE_300],
    duration: '¥0.096/个',
    description: '300橙豆',
    discount: '超低价',
    category: 'points'
  },
  {
    type: ProductType.ORANGE_BEAN_PACKAGE_500,
    title: '500橙豆',
    price: PriceConfig[ProductType.ORANGE_BEAN_PACKAGE_500],
    duration: '¥0.091/个',
    description: '500橙豆',
    discount: '最具性价比',
    category: 'points'
  },
  {
    type: ProductType.ORANGE_BEAN_PACKAGE_1000,
    title: '1000橙豆',
    price: PriceConfig[ProductType.ORANGE_BEAN_PACKAGE_1000],
    duration: '¥0.089/个',
    description: '1000橙豆',
    discount: '全网最低',
    category: 'points'
  }
];
